export enum AuthRoutes {
	SIGN_IN = "/auth/sign-in/",
	SIGN_UP = "/auth/sign-up/",
	LOGIN_WITH_GOOGLE = "/auth/login-with-google/",
	OAUTH2CALLBACK = "/auth/oauth2callback/",
	REFRESH = "/auth/refresh/",
	CHANGE_PASSWORD = "/auth/update-password/",
	DELETE_USER = "/auth/delete-user/",
}
